import { pdfjs } from 'react-pdf';

// Must match the pdfjs-dist version bundled with react-pdf (cdnjs "pdf.js" paths often 404 or mismatch).
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;